<template>
  <div class="DMAdashboard">
    <div class="PagePanel">
      <div class="row">
        <div class="col-md-6">
          <div id="DMASelectBox">
            <DxSelectBox
              :data-source="isCcrCompany || isBroadcasterFlag() ? Ccr_DMAs : NonCcr_DMAs"
              placeholder=" "
              valueExpr="MarketID"
              :displayExpr="formatDMA"
              :value="dmaID"
              @valueChanged="changeDMA"
              :onSelectionChanged="onSelectionChanged"
              :searchEnabled="true"
            ></DxSelectBox>
          </div>
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-4" v-if="isNielsenCompany">
          <DxButtonGroup
            style="float: right"
            :items="filterBtns"
            styling-mode="outlined"
            key-expr="text"
            @item-click="onFilterClick"
            :selected-item-keys="InitialKey"
            :disabled="filterBtn.disabled"
          ></DxButtonGroup>
        </div>
      </div>
    </div>
    <!-- Dashboard tab content starts -->
    <div v-show="showDashboard">
      <div v-if="isCcrCompany || isBroadcasterFlag()">
        <CCRDashboardSection
          :dmaID="dmaID"
          :dmaNameForFilter="dmaNameForFilter"
          :dmaNameAndRank="dmaNameAndRank"
          :mapData="mapData"
        ></CCRDashboardSection>
      </div>
      <div v-else>
        <NonCCRDashboardSection
          :dmaID="dmaID"
          :dmaNameForFilter="dmaNameForFilter"
          :dmaNameAndRank="dmaNameAndRank"
          :mapData="mapData"
        ></NonCCRDashboardSection>
      </div>
    </div>
    <!-- Dashboard tab content ends -->

    <!-- Project tab content starts-->
    <div v-show="!showDashboard">
      <div class="PagePanel" v-if="!isCcrCompany || !isBroadcasterFlag()">
        <div class="headerTitle">Project</div>
        <ProjectGrid
          :DS_Project="DS_Project"
          @filter-channels-list="filterChannelList"
          @set-phase-name="setPhaseName"
          :clientProjectId="clientProjectId"
          :clientProjectPhaseID="clientProjectPhaseID"
        />
      </div>
      <div class="PagePanel">
        <div class="headerTitle">Channel List - {{ ProjectName }}</div>
        <div v-if="!isCcrCompany || !isBroadcasterFlag()">
          <NonCCRChannelList
            :Dmachannels="NonCcrDmachannels"
            :GridType="GridType"
            :milestoneFilter="MilestoneFilterBtns"
          />
        </div>
      </div>
    </div>
    <!-- Project tab content ends-->
  </div>
</template>

<script>
import "devextreme/data/odata/store";
import ProjectGrid from "./project/ProjectGrid";
import CCRDashboardSection from "./dashboardSection/CCRDashboardSection.vue";
import NonCCRDashboardSection from "./dashboardSection/NonCCRDashboardSection.vue";
import CCRChannelList from "./project/channelList/CCRChannelList";
import NonCCRChannelList from "./project/channelList/NonCCRChannelList.vue";
import { DxButtonGroup } from "devextreme-vue/button-group";
import { DxSelectBox } from "devextreme-vue/select-box";
import { EventBus } from "../../components/Events";
import { isBroadcasterFlag } from "../../sharedCode/sharedFunctions"
export default {
  name: "Dashboard",
  components: {
    DxSelectBox,
    DxButtonGroup,
    CCRChannelList,
    NonCCRChannelList,
    ProjectGrid,
    CCRDashboardSection,
    NonCCRDashboardSection,
  },
  data() {
    return {
      InitialKey: ["Dashboard"],
      dmaID: parseInt(this.$route.params.id),
      showDashboard: true,
      filterBtn: [
        { text: "Dashboard", hint: "Dashboard", disabled: false },
        {
          text: "Project",
          hint: "Project",
          disabled: false,
        },
      ],
      //hardcoded for project identidfication
      clientProjectId: 1,
      ProjectName: "TAM Project",
      dmaNameForFilter: null,
      dmaNameAndRank: null,
      currentFilter: null,
      mapData: null,
      GridType: "OnDashboard",
      MilestoneFilterBtns: [],
      clientProjectPhaseID: null,
      filterProjectGrid: false,
    };
  },
  mounted: function () {
    this.LoadMilestoneFilters();
    EventBus.$on("DMA-Filter", (filterType) => {
      this.showDashboard = filterType == "Dashboard";
      this.InitialKey = [filterType];
      this.currentFilter = filterType;
    });
    EventBus.$on("Project-Filter-Report", (filterData) => {
      this.clientProjectPhaseID = filterData[0];
      this.clientProjectId = filterData[1];
      //this.filterProjectGrid = !this.filterProjectGrid;
    });
  },
  methods: {
    isBroadcasterFlag,
    LoadMilestoneFilters() {
      let url = `https://api.ccr.net/ColoM360/MilestoneStatus`;
      this.$axios.get(url).then((response) => {
        response.data.value.forEach((element) => {
          if (element.MilestoneStatusName != "Not Tracked") {
            let itemOjb = {
              text: element.MilestoneStatusName,
              hint: element.MilestoneStatusName,
              filter: element.MilestoneStatusID,
              color: element.MilestoneStatusColor,
            };
            this.MilestoneFilterBtns.push(itemOjb);
          }
        });

        this.MilestoneFilterBtns.push({
          text: "All",
          hint: "Show All",
          filter: "all",
        });
      });
    },
    onSelectionChanged(e) {
      this.dmaNameForFilter =
        e.selectedItem?.DMA_Name ?? e.selectedItem?.MarketName;
      let dmaRank = e.selectedItem?.Rank ? "(" + e.selectedItem.Rank + ")" : "";
      this.dmaNameAndRank = this.dmaNameForFilter + " " + dmaRank;
    },
    onFilterClick(e) {
      //Show Dashboard tab otherwise Project...
      this.showDashboard = e.itemData.text == "Dashboard" ? true : false;
      this.currentFilter =
        e.itemData.text == "Dashboard" ? "Dashboard" : "Project";
      if (this.showDashboard) EventBus.$emit("resize-chart");
    },
    changeDMA: function (e) {
      if (this.isCcrCompany || this.isBroadcasterFlag()) {
        this.$router.push({
          name: this.$route.name,
          params: {
            id: e.value,
            eventId: this.$route.params?.eventId,
            filter: "Dashboard",
          },
        });
      } else {
        this.$router.push({
          name: this.$route.name,
          params: {
            id: e.value,
            eventId: this.$route.params?.eventId,
          },
        });
        if (!this.isNielsenCompany) this.currentFilter = "Dashboard";
        setTimeout(() => {
          EventBus.$emit("DMA-Filter", this.currentFilter);
        }, 1);
      }
    },
    formatDMA: function (item) {
      if (item) {
        this.mapData = item;
        let marketName = item?.MarketName;
        let rank = item?.Rank == null ? "" : " (" + item.Rank + ")";
        return item && marketName + rank;
      }
    },
    setPhaseName(projectPhaseName) {
      this.ProjectName = projectPhaseName;
    },
    filterChannelList(ProjectData) {
      //this.$refs.channelsList.filterGridByClientProjectID(selectedClientProjectID);
      this.clientProjectId = ProjectData.data.ClientProjectID;
      if (ProjectData.filterType == "project") {
        this.ProjectName = ProjectData.data.ClientProjectName;
        this.clientProjectPhaseID = null;
      } else {
        this.clientProjectPhaseID = ProjectData.data.ClientProjectPhaseID;
        this.ProjectName = ProjectData.data.ProjectPhaseCombinedName;
      }
    },
  },
  computed: {
    filterBtns() {
      return this.isNielsenCompany
        ? this.filterBtn
        : this.filterBtn.slice(0, 1);
    },
    user() {
      return this.$auth.user.UserDetails;
    },
    isNielsenCompany() {
      return this.user.Company_RecID == 20822;
    },
    isCcrCompany() {
      let isCcr =
        this.user.Company_RecID == 2 && this.user.Contact_Company_RecID == 2;

      this.filterBtn[1].disabled = isCcr;
      return isCcr;
    },
    DS_Project: function () {
      var company = this.user.Company_RecID;
      var ContactCompany = this.user.Contact_Company_RecID;
      var token = this.user.id_token;
      return {
        store: {
          type: "odata",
          url: "https://api.ccr.net/ColoM360/ClientProjectPhase_View",
          key: "ClientProjectID",
          version: 4,
          beforeSend: function (request) {
            let headers = {
              Authorization: `Bearer ${token}`,
            };
            if (ContactCompany != company) {
              headers["CompanyID"] = company;
            }
            request.headers = headers;
            let pth = request.url;
            if (pth[pth.length - 1] != ")") {
              if (request.params.$filter == undefined) {
                request.params.$filter = "(Company_RecID eq " + company + ")";
              } else {
                request.params.$filter =
                  "(" +
                  request.params.$filter +
                  ") and (Company_RecID eq " +
                  company +
                  ")";
              }
            }
          },
          errorHandler: (error) => {
            if (error.httpStatus == 401) {
              this.$auth.logout({ returnTo: `${window.location.origin}` });
            }
          },
        },
      };
    },
    Ccr_DMAs: function () {
      if (this.isCcrCompany || this.isBroadcasterFlag()) {
        let th = this;
        return {
          store: {
            type: "odata",
            url: "https://api.ccr.net/ColoM360/M360Global_DMA_DropDownList_View",
            key: "view_id",
            version: 4,
            beforeSend: function (request) {
              let headers = {
                Authorization: `Bearer ${th.user.id_token}`,
              };
              request.headers = headers;
            },
            errorHandler: (error) => {
              if (error.httpStatus == 401) {
                this.$auth.logout({ returnTo: `${window.location.origin}` });
              }
            },
          },
          sort: { field: "MarketName", asc: true },
          paginate: true,
          pageSize: 10,
        };
      }
    },
    NonCcr_DMAs: function () {
      if (!this.isCcrCompany || !this.isBroadcasterFlag()) {
        let th = this;
        return {
          store: {
            type: "odata",
            url: "https://api.ccr.net/ColoM360/DMA_CompanyDropDownList_View",
            key: "RequestPlanID",
            version: 4,
            beforeSend: function (request) {
              let headers = {
                Authorization: `Bearer ${th.user.id_token}`,
              };
              if (th.user.Contact_Company_RecID != th.user.Company_RecID) {
                headers["CompanyID"] = th.user.Company_RecID;
              }
              request.headers = headers;

              let pth = request.url;
              if (pth[pth.length - 1] != ")") {
                if (request.params.$filter == undefined) {
                  request.params.$filter =
                    "( Company_RecID eq " + th.user.Company_RecID + ")";
                } else {
                  request.params.$filter =
                    "(" +
                    request.params.$filter +
                    ") and ( Company_RecID eq " +
                    th.user.Company_RecID +
                    ")";
                }
              }
            },
            errorHandler: (error) => {
              if (error.httpStatus == 401) {
                this.$auth.logout({ returnTo: `${window.location.origin}` });
              }
            },
          },
          paginate: true,
          pageSize: 10,
        };
      }
    },
    // CcrDmachannels: function () {
    //   var DMA_RecID = this.dmaID;
    //   var token = this.user.id_token;
    //   return {
    //     store: {
    //       type: "odata",
    //       url: "https://api.ccr.net/ColoM360/M360Global_ProductInstanceChannel_View",
    //       key: "CM_SiteChannel_RecID",
    //       version: 4,
    //       beforeSend: function (request) {
    //         let headers = {
    //           Authorization: `Bearer ${token}`,
    //         };
    //         request.headers = headers;
    //         let pth = request.url;
    //         if (pth[pth.length - 1] != ")") {
    //           if (request.params.$filter == undefined) {
    //             request.params.$filter = "(DMA_RecID eq " + DMA_RecID + ")";
    //           } else {
    //             request.params.$filter =
    //               "(" + request.params.$filter + "(DMA_RecID eq " + DMA_RecID;
    //           }
    //         }
    //       },
    //     },
    //   };
    // },
    NonCcrDmachannels: function () {
      var clientProjectPhaseID = this.clientProjectPhaseID;
      var client_project_id = this.clientProjectId;
      var company = this.user.Company_RecID;
      var DMA_RecID = this.dmaID;
      var ContactCompany = this.user.Contact_Company_RecID;
      var token = this.user.id_token;
      return {
        store: {
          type: "odata",
          url: "https://api.ccr.net/ColoM360/ProductInstanceChannel_View",
          key: "ProductInstanceID",
          version: 4,
          beforeSend: function (request) {
            let headers = {
              Authorization: `Bearer ${token}`,
            };
            if (ContactCompany != company) {
              headers["CompanyID"] = company;
            }
            request.headers = headers;
            let pth = request.url;
            if (pth[pth.length - 1] != ")") {
              if (request.params.$filter == undefined) {
                request.params.$filter =
                  "(Company_RecID eq " +
                  company +
                  ") and (DMA_RecID eq " +
                  DMA_RecID +
                  ") and (ClientProjectID eq " +
                  client_project_id +
                  ")";
              } else {
                request.params.$filter =
                  "(" +
                  request.params.$filter +
                  ") and (Company_RecID eq " +
                  company +
                  ") and (DMA_RecID eq " +
                  DMA_RecID +
                  ") and (ClientProjectID eq " +
                  client_project_id +
                  ")";
              }
              if (clientProjectPhaseID != null && clientProjectPhaseID != 0) {
                request.params.$filter =
                  "(" +
                  request.params.$filter +
                  ") and (ClientProjectPhaseID eq " +
                  clientProjectPhaseID +
                  ")";
              }
            }
          },
          errorHandler: (error) => {
            if (error.httpStatus == 401) {
              this.$auth.logout({ returnTo: `${window.location.origin}` });
            }
          },
        },
      };
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("https://fonts.googleapis.com/css2?family=Lato");
.dx-widget.dx-visibility-change-handler {
  max-width: none !important;
}
.DMAdashboard {
  background-color: #f1f1f1;
  color: black;
  width: 100%;
  padding: 8px;
}
.PagePanel {
  width: 100%;
  border: 1px solid #e0e0e0;
  border-radius: 4px;
  margin: 0;
  border: 1px solid lightgray;
  padding: 15px;
  background-color: white;
  margin-bottom: 8px;
}
.headerTitle {
  color: #006ca5;
  font-size: 18px;
  font-weight: bold;
  padding-bottom: 5px;
}
#DMASelectBox::v-deep {
  .dx-selectbox {
    background: #fff;
    border: none;
    -webkit-box-shadow: none;
    -moz-box-shadow: none;
    box-shadow: none;
  }

  .dx-texteditor-container {
    font-family: "Lato", sans-serif;
    font-size: 16px;
    font-weight: bold;
  }

  .dx-texteditor-input-container:focus,
  .dx-dropdowneditor-input-wrapper:focus,
  .dx-texteditor-container:focus {
    outline: none;
  }

  .dx-placeholder {
    color: #006ca5;
    font-family: "Lato", sans-serif;
    font-size: 16px;
    font-weight: bold;
  }

  .dx-texteditor.dx-state-focused.dx-editor-outlined {
    border: none;
  }

  .dx-texteditor-input {
    font-family: "Lato", sans-serif;
    font-size: 20px;
    font-weight: bold;
    padding: 5px 10px 10px 0;
    color: #006ca5;
  }
  .dx-dropdowneditor-icon {
    color: #006ca5;
    font: 40px/40px DXIcons;
  }
  .dx-dropdowneditor-icon:before {
    margin-top: -15px;
    margin-left: -20px;
  }
}
</style>